import { BaseQuestionnaireRoute } from '../slice';
import { businessTypeRoutes , BusinessTypeRoutes  }from './businessType';
import { generalInfoRoutes , GeneralInfoRoutes  }from './generalInfo';
import { ownersRoutes , OwnersRoutes  }from './owners';
import { industryandprimaryactivityRoutes , IndustryandprimaryactivityRoutes  }from './industryandprimaryactivity';


export type BusinessInfoRoutes = BaseQuestionnaireRoute & {

  businessType : BusinessTypeRoutes;  
generalInfo : GeneralInfoRoutes;  
owners : OwnersRoutes;  
industryandprimaryactivity : IndustryandprimaryactivityRoutes;  


 
};

export const businessInfoRoutes: { businessInfo: BusinessInfoRoutes } = {
    businessInfo: {
    title: 'Business Info',
    path: 'businessInfo',
    isValid: undefined,
    ...businessTypeRoutes, 
...generalInfoRoutes, 
...ownersRoutes, 
...industryandprimaryactivityRoutes, 

   
  
  },
};
